import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '../types';
import { OfferPreview, Offer } from './offerTypes';

export const state: Offer = new Offer();

export const SPECIAL_OFFER_PREVIEW_STORAGE_KEY = '@twism:special-offer-preview';

const actions: ActionTree<Offer, RootState> = {
  SET_PREVIEW_INFORMATION(context, payload: Offer) {
    context.commit('setInformationPreview', payload);
  }
};

const mutations: MutationTree<Offer> = {
  setInformationPreview(state, payload: OfferPreview) {
    state.OfferPreview = { ...state.OfferPreview, ...payload };
  }
};

const getters: GetterTree<Offer, RootState> = {
  getOfferInformation(state) {
    return state;
  }
};

const namespaced: boolean = true;

export const offer: Module<Offer, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
